import { environment } from 'src/environment';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LoggerService } from 'src/app/core/authentication/logger.service';
import { BaseService, SettingsService, StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { EditAccountService } from 'src/app/core/services/edit-account.service';
import { MyAccountService } from 'src/app/core/services/my-account.service';
import { UikitService } from 'src/app/core/services/uikit.service';
import * as uikit from 'uikit'
import { ApplicationService } from 'src/app/core/services/application.service';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';
@Component({
  selector: 'app-edit-account',
  templateUrl: './edit-account.component.html',
  styleUrls: ['./edit-account.component.scss', '../modal-screens.scss']
})
export class EditAccountComponent implements OnInit, OnDestroy{

  config: any;
  editUsernameForm: FormGroup;
  myAccountData;
  userName;
  userPicture;
  userLoginBy;
  uId: string;
  form = new FormData();
  updatedData;
  imagePath;
  showSuccess:boolean = false;
  successMessage: string;
  editAccountForm: FormGroup;
  userEmail;
  userMobile;
  closeEditAccountSubscribe;

  @Input() page;
  @Input() userDataChild;
  @Output() newItemEvent? = new EventEmitter<string>();
  @Output() updateTitleEvent? = new EventEmitter<string>();

  skinName = environment.skinName;
  constructor(public configService: ConfigurationService, private formBuilder: FormBuilder, private storageService: StorageService,
    private uikitService: UikitService, private editService: EditAccountService, private accountService: MyAccountService,
    public baseService: BaseService, private settingsService: SettingsService, private loggerService: LoggerService, private applicationService:ApplicationService,
    private analyticsService: InhouseAnalyticsService) {
      this.closeEditAccountSubscribe = this.applicationService.closeEditAccount.subscribe(data =>{ if(data) this.userName = '';})
    }

  ngOnInit(): void {
    uikit.util.on(document, 'beforehide', '#edit-account', ()=>{
      this.showSuccess = false;
      this.getAccount();
    });
    this.imagePath = this.settingsService.imagePath;
    this.editAccountForm = this.formBuilder.group({
      user_name: [this.userName],
      user_email: [this.userEmail],
      user_mobile: [this.userMobile],
      user_picture: [this.userPicture]
    });
    this.editUsernameForm = this.formBuilder.group({
      user_name: [this.userName],
    });
    this.getAccount();
    this.uId = this.storageService.getLocalStore('u_id');
  }

  getAccount() {
    if (this.page == 'account' && this.userDataChild) {
      this.processAccountData(this.userDataChild);
    } else {
      this.accountService.getAccountDetails().subscribe(
        (res) => {
          this.baseService.loaderSource.next(false);
          this.myAccountData = res;
          this.processAccountData(this.myAccountData);
        },
        (error) => {
          console.error('Error occurred:', error);
        }
      );
    }
  }
  processAccountData(data: any) {
    if (data.status_code === 200) {
      this.userName = data.user_name;
      this.userEmail = data.user_email;
      this.userMobile = data.user_mobile;
      this.userPicture = this.settingsService.imagePath + data.user_picture;
      this.userLoginBy = data.user_login_by;
  
      if (this.userPicture.indexOf('http://') !== 0 && this.userPicture.indexOf('https://') !== 0) {}
      else this.userPicture = this.settingsService.imagePath + this.userPicture;
    } else {
      this.uikitService.notifyError(data.error.message);
    }
  }


  editAccount() {
    var disableButton = document.querySelector('.submit-btn');
    disableButton.setAttribute('disabled', '')
    setTimeout(function() {
      disableButton.removeAttribute("disabled");
    }, 2500);
    let nameRequired = this.configService.localeKeys?.["account.name_required.text"];
    let nameLength = this.configService.localeKeys?.["account.name_length.text"];
    if (this.userName === '' || this.userName === undefined) {
      this.uikitService.staticErrorMessage(nameRequired);
      return;
    }
    if (this.userName.length < 3) {
      this.uikitService.staticErrorMessage(nameLength);
      return;
    }
    const countryCode = this.storageService.getLocalStore('country_code');
    const locale = this.storageService.getLocalStore('locale');
    const region = this.storageService.getLocalStore('region');
    this.form.append('name', this.editUsernameForm.get('user_name').value);
    this.form.append('login_by', this.userLoginBy);
    this.form.append('u_id', this.uId);
    this.form.append('country_code', countryCode);
    this.form.append('locale', locale);
    this.form.append('region', region);
    let data = {};
    this.form.forEach(function(value, key){
      data[key] = value;
    });
    this.editService.editAccountFun(data).subscribe({
      next: res => {
        const eventObj = {
          event_type: 'event',
          event_name: 'Edit user Name',
          event_status: 'Success',
        };
        this.analyticsService.trackUserActions(eventObj);

        this.updatedData = res;
      }, error: (err) => {
        const eventObj = {
          event_type: 'event',
          event_name: 'Edit user Name',
          event_status: 'Failure',
          event_description: err.error?.error?.message
        };
        this.analyticsService.trackUserActions(eventObj);
      }, complete: () => {
        if (this.updatedData.status_code === 200) {
          //this.uikitService.staticSuccessMessage(this.updatedData.message);
          const updateMemoryData: any = {};
          updateMemoryData.login_by = this.updatedData.data.user_login_by;
          updateMemoryData.user_picture = this.updatedData.data.user_picture;
          updateMemoryData.user_name = this.updatedData.data.user_name;
          updateMemoryData.user_type = this.updatedData.data.user_type;
          updateMemoryData.user_telco = this.updatedData.data.user_telco;
          updateMemoryData.one_time_subscription = this.updatedData.data.one_time_subscription;
          this.loggerService.updatedMemoryStorage(updateMemoryData);
          this.storageService.setLocalStore('sessionStorage', updateMemoryData);
          this.storageService.setLocalStore('event_user_status', this.updatedData.data.user_type);
          this.updateTitleEvent.emit(this.configService.localeKeys?.["account.success.text"]);
          // this.router.navigateByUrl('/account/settings');
          this.showSuccess = true;
          this.successMessage =this.updatedData.message;
          if(this.newItemEvent)
            this.newItemEvent.emit('hello');
        } else {
          this.uikitService.staticErrorMessage(this.updatedData.error.message);
          this.showSuccess = false;
        }
        if (this.updatedData.error && this.updatedData.error.code !== 1002) {
          this.uikitService.staticErrorMessage(this.updatedData.error.message);
          this.showSuccess = false;
        }
      }
    });

  }

  ngOnDestroy(): void {
    this.closeEditAccountSubscribe.unsubscribe();
  }
}
